export enum ButtonVariant {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Danger = 'danger',
    Ghost = 'ghost',
    DangerGhost = 'danger_ghost'
}

export enum ButtonSize {
    Small = 'small',
    Medium = 'medium',
    Big = 'big',
    Tiny = 'tiny'
}
